import FormControl from "../base/FormControl";

export default class InputText extends FormControl {

    constructor(props) {
        super(props);
        this.state.type = "text";
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    render() {
        return super.render();
    }
}